

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import VerificationPanelList from './verification/VerificationPanelList';

const SIDEBAR_ITEMS = [
  { key: 'stats', label: '📊 Overview' },
  { key: 'users', label: '👥 Users' },
  { key: 'agents', label: '🧑‍💼 Agents' },
  { key: 'jobs', label: '💼 Jobs' },
  { key: 'aadhaar', label: '🪪 Aadhaar Requests' },
  { key: 'verification', label: '🛡️ Company Verification' },
  { key: 'job-aggregator', label: '🔎 Job Aggregator' },
  { key: 'aggregator-dashboard', label: '📊 Aggregator Dashboard' },
  { key: 'job-review', label: '📝 Job Review' },
  { key: 'support-tickets', label: '🎫 Support Tickets' },
  { key: 'master', label: '🗂️ Master' },
  { key: 'analytics', label: '📈 Analytics' },
];

function AdminVerification() {
  const navigate = useNavigate();
  const [user] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  // This page IS the "verification" tab. Any other sidebar item takes the
  // admin back to the main Admin Panel, which owns those tabs' data/logic.
  const handleSidebarClick = (key) => {
    if (key === 'verification') return;
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-[#EFF6FF]">
      <Navbar user={user} />

      {/* Sidebar - fixed, same layout/styling as AdminPanel */}
      <div className="w-64 bg-[#0D1B3D] rounded-xl p-6 text-white fixed top-24 left-4 h-[calc(100vh-7rem)] overflow-y-auto">
        <h2 className="text-xl font-bold mb-8">Admin Panel</h2>
        <div className="space-y-2">
          {SIDEBAR_ITEMS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleSidebarClick(tab.key)}
              className={`block w-full text-left rounded-lg p-3 transition ${
                tab.key === 'verification' ? 'bg-[#2563EB]' : 'hover:bg-[#2563EB]'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-7xl mx-auto py-8 px-4 pl-72">
        <div className="bg-white rounded-xl shadow p-8 mb-6">
          <h2 className="text-3xl font-bold text-[#0D1B3D]">Admin Overview</h2>
          <p className="text-gray-500 mt-2">Manage users, jobs, and platform stats</p>
        </div>

        <VerificationPanelList
          apiPrefix="/admin/verification"
          detailPathPrefix="/admin/verification"
        />
      </div>

      {/* <Footer /> */}
    </div>
  );
}

export default AdminVerification;